export const BILLS_SUMMARY_TYPE = {
  ALL: 'all',
  SOME: 'some',
  NONE: 'none'
};

export const BILLS_TYPE = {
  WATER: 'water',
  ELECTRICITY: 'electricity',
  GAS: 'gas',
  INTERNET: 'internet'
};

export const GAS_INSTALLATION = 'gas-installation';
